import { createSlice } from '@reduxjs/toolkit';
import surveyEndpoint from 'app/api/services/surveyEndpoint';

const initialState = {
  systemClassification: [],
  subitemComponent: [],
  defectClassification: [],
};

const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    getSystemClassification(state, action) {
      state.systemClassification = action.payload;
    },
    clearSystemClassification(state, action) {
      state.services = initialState.systemClassification;
    },
    getSubitemComponent(state, action) {
      state.subitemComponent = action.payload;
    },
    clearSubitemComponent(state, action) {
      state.documents = initialState.subitemComponent;
    },
    getDefectClassification(state, action) {
      state.defectClassification = action.payload;
    },
    clearDefectClassification(state, action) {
      state.documents = initialState.defectClassification;
    },
  },
});

export const fetchMaxAgeVehicle = async (params, context) => {
  let response = [];
  response = await surveyEndpoint.maxAgeVehicle(params, context);
  return response.data;
};

export const fetchSystemClassification = () => async dispatch => {
  let response = [];
  response = await surveyEndpoint.getSystemClassification();
  dispatch(getSystemClassification(response.data));
};

export const fetchSubitemComponent = () => async dispatch => {
  let response = [];
  response = await surveyEndpoint.getSubitemComponent();
  dispatch(getSubitemComponent(response.data));
};

export const fetchDefectClassification = (cdClassificacaoSistema, cdSubitemComponente) => async dispatch => {
  let response = [];
  response = await surveyEndpoint.getDefectClassification(cdClassificacaoSistema, cdSubitemComponente);
  dispatch(getDefectClassification(response.data));
};

export const {
  getSystemClassification,
  clearSystemClassification,
  getSubitemComponent,
  clearSubitemComponent,
  getDefectClassification,
  clearDefectClassification,
} = surveySlice.actions;

export default surveySlice;
